import { __decorate, __extends } from "tslib";
import { NodeMaterialBlock } from '../nodeMaterialBlock';
import { NodeMaterialBlockConnectionPointTypes } from '../Enums/nodeMaterialBlockConnectionPointTypes';
import { NodeMaterialBlockTargets } from '../Enums/nodeMaterialBlockTargets';
import { _TypeStore } from '../../../Misc/typeStore';
import { editableInPropertyPage, PropertyTypeForEdition } from "../nodeMaterialDecorator";
/**
 * Block used to clamp a float
 */
var ClampBlock = /** @class */ (function (_super) {
    __extends(ClampBlock, _super);
    /**
     * Creates a new ClampBlock
     * @param name defines the block name
     */
    function ClampBlock(name) {
        var _this = _super.call(this, name, NodeMaterialBlockTargets.Neutral) || this;
        /** Gets or sets the minimum range */
        _this.minimum = 0.0;
        /** Gets or sets the maximum range */
        _this.maximum = 1.0;
        _this.registerInput("value", NodeMaterialBlockConnectionPointTypes.AutoDetect);
        _this.registerOutput("output", NodeMaterialBlockConnectionPointTypes.BasedOnInput);
        _this._outputs[0]._typeConnectionSource = _this._inputs[0];
        return _this;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */
    ClampBlock.prototype.getClassName = function () {
        return "ClampBlock";
    };
    Object.defineProperty(ClampBlock.prototype, "value", {
        /**
         * Gets the value input component
         */
        get: function () {
            return this._inputs[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ClampBlock.prototype, "output", {
        /**
         * Gets the output component
         */
        get: function () {
            return this._outputs[0];
        },
        enumerable: false,
        configurable: true
    });
    ClampBlock.prototype._buildBlock = function (state) {
        _super.prototype._buildBlock.call(this, state);
        var output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + (" = clamp(" + this.value.associatedVariableName + ", " + this._writeFloat(this.minimum) + ", " + this._writeFloat(this.maximum) + ");\r\n");
        return this;
    };
    ClampBlock.prototype._dumpPropertiesCode = function () {
        var codeString = this._codeVariableName + ".minimum = " + this.minimum + ";\r\n";
        codeString += this._codeVariableName + ".maximum = " + this.maximum + ";\r\n";
        return codeString;
    };
    ClampBlock.prototype.serialize = function () {
        var serializationObject = _super.prototype.serialize.call(this);
        serializationObject.minimum = this.minimum;
        serializationObject.maximum = this.maximum;
        return serializationObject;
    };
    ClampBlock.prototype._deserialize = function (serializationObject, scene, rootUrl) {
        _super.prototype._deserialize.call(this, serializationObject, scene, rootUrl);
        this.minimum = serializationObject.minimum;
        this.maximum = serializationObject.maximum;
    };
    __decorate([
        editableInPropertyPage("Minimum", PropertyTypeForEdition.Float)
    ], ClampBlock.prototype, "minimum", void 0);
    __decorate([
        editableInPropertyPage("Maximum", PropertyTypeForEdition.Float)
    ], ClampBlock.prototype, "maximum", void 0);
    return ClampBlock;
}(NodeMaterialBlock));
export { ClampBlock };
_TypeStore.RegisteredTypes["BABYLON.ClampBlock"] = ClampBlock;
//# sourceMappingURL=clampBlock.js.map